import { useEffect } from 'react';

import { useAuth } from '@/hooks/useAuth';

const UmamiIdentify = () => {
    const { isAuthenticated, user } = useAuth();

    useEffect(() => {
        if (!isAuthenticated || !user?.email) {
            return;
        }

        window.umami?.identify(user.email, { email: user.email });
    }, [isAuthenticated, user?.email]);

    return null;
};

export { UmamiIdentify };
